const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000
});


var iForms = {
    async addAjaxForm(el){
        el.addEventListener('submit', function (event) {
            event.preventDefault();
            var url = event.target.action;
            var method = event.target.method;
            var data = new FormData(event.target);

            var elements = event.target.getElementsByTagName('input');

            for (var j = 0; j < elements.length; j++) {
                if (elements[j].dataset.phone !== undefined) {
                    var ei = window.intlTelInputGlobals.getInstance(elements[j]);
                    data.append(elements[j].name, ei.getNumber());
                }
            }

            if(typeof formBuilder === 'object'){
                data.append('formBuilder', JSON.stringify(formBuilder.actions.getData()));
            }

            fetch(url, {
                method: 'POST',
                body: data
            }).then(t => {
                t.text().then(json => {
                    var data = JSON.parse(json);
                    if (data.error === undefined) {
                        Toast.fire({
                            type: 'success',
                            title: 'Sikeres művelet!'
                        });
                    } else {
                        Toast.fire({
                            type: 'error',
                            title: data.message
                        });
                    }
                });
            });

        }, false);

    },
    load: function(){
        if (document.getElementsByClassName('ajaxform') !== undefined) {
            var ds = document.getElementsByClassName('ajaxform');
            for (i = 0; i < ds.length; i++) {
                this.addAjaxForm(ds[i]);
            }
        }
    }
};
window.addEventListener('load', function (event) {
    iForms.load();
}, false);